/**
 * referralCard — s106: which referral request Case Home shows, and in which state (A5 / A6 / A8).
 * The newest request that is waiting ('requested') or on file; a waiting one past its own due_at
 * (the API's _ref_due_at) is 'overdue'. Cancelled and can't-refer requests show nothing. PURE.
 * @returns {{request, state: 'waiting'|'overdue'|'on_file'}|null}
 */
export function referralCardState(requests, nowMs) {
  const list = Array.isArray(requests) ? requests : []
  const ts = (r) => { const x = Date.parse(r && r.requested_at); return Number.isFinite(x) ? x : 0 }
  const live = list.filter((r) => r && (r.status === 'requested' || r.status === 'on_file')).sort((a, b) => ts(b) - ts(a))
  const rq = live[0]
  if (!rq) return null
  if (rq.status === 'on_file') return { request: rq, state: 'on_file' }
  const due = Date.parse(rq.due_at)
  return { request: rq, state: Number.isFinite(due) && nowMs > due ? 'overdue' : 'waiting' }
}
